import {annotate} from "rough-notation";
import AOS from 'aos';
const pubOrdNumAnnotations = {};
const pubPrevAnnotations = {};

function highlight_element(element) {
    const e = document.querySelector(element);
    const annotation = annotate(e, { type: 'underline' });
    annotation.show();
}

function render_pub_ordinal() {
    const pub_ords = document.querySelectorAll(".pub-ordinal-number");
    pub_ords.forEach((element) => {
        // Check if the element already has an annotation object
        const existingAnnotation = pubOrdNumAnnotations[element.id];
        if (!existingAnnotation) {
            // Create a RoughNotation for each element
            const annotation = annotate(element, {
                type: 'underline', iterations: 3, padding: [5, 5, 5, 5]
            });
            // Save the annotation object in the dictionary with the element's ID as the key
            pubOrdNumAnnotations[element.id] = annotation;
            // Show the annotation
            annotation.show();
        }else{
            existingAnnotation.hide();
            existingAnnotation.show();
        }

    });
}

function render_pub_preview() {
    const img_sketch_colors = ["#f1e3f3", "#c2bbf0", "#8fb8ed", "#62bfed", "#3590f3", "#f7c59f"];
    const pub_img_sketches = document.querySelectorAll(".pub-fig-sketch");
    pub_img_sketches.forEach((element) => {
        // Check if the element already has an annotation object
        const existingAnnotation = pubPrevAnnotations[element.id];
        if (!existingAnnotation) {
            const annotation = annotate(element, {
                type: 'box',
                padding: [1, 1, 1, 1],
                strokeWidth: 2,
                iterations: 3,
                color: img_sketch_colors[(Math.floor(Math.random() * img_sketch_colors.length))],
                animate: true
            });
            // Save the annotation object in the element's data attribute
            pubPrevAnnotations[element.id] = annotation;
            annotation.show();
        }else{
            pubPrevAnnotations[element.id].hide();
            pubPrevAnnotations[element.id].show();
        }
    });
}

function trigger_card_view(elementId) {
    let checkbox = document.getElementById(elementId);

    if (!checkbox) {
        console.error('Element with ID ' + elementId + ' not found.');
        return;
    }

    function f() {
        let cards = document.getElementById("pubCardView");
        let lists = document.getElementById("pubListView");
        if (cards && lists) {
            if (checkbox.checked) {
                lists.classList.add("visually-hidden");
                cards.classList.remove("visually-hidden");
                AOS.init();
                render_pub_ordinal();
                render_pub_preview();
            } else {
                cards.classList.add("visually-hidden");
                lists.classList.remove("visually-hidden");
                AOS.init();
                render_pub_ordinal();
                render_pub_preview();
            }
        }
    }
    checkbox.addEventListener('change', f);
    f();
}

// const sketch_links = document.querySelectorAll(".sketch-link");
// sketch_links.forEach((element) => {
//     const annotation = annotate(element, {
//         type: 'underline',
//         color: 'yellow'
//     });
//     annotation.show();
// });
export {render_pub_ordinal, render_pub_preview, trigger_card_view, highlight_element};
